<template>
  <XMessage>
    <MessageGlobalInit />
    <router-view></router-view>
  </XMessage>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useTheme } from "@/hooks/useTheme";
import MessageGlobalInit from "@/components/MessageGlobalInit.vue";
import XMessage from "@/components/XMessage/index.vue";
import { LanguageType } from "./store/interface";
import { useGlobalStore } from "@/store/modules/global";
import { setupRequiredAsteriskStyling } from "@/utils/requiredAsterisk";

const globalStore = useGlobalStore();

// init theme
const { initTheme } = useTheme();
initTheme();

// init language
const i18n = useI18n();
onMounted(() => {
  i18n.locale.value = "en";
  globalStore.setGlobalState("language", "en" as LanguageType);
  setupRequiredAsteriskStyling();
});
</script>
